import React from "react";
import { TStaticDrawFunction } from "../../../Components/Canvas";
import { MeasurementChartPainter } from "./MeasurementChartPainter";
import MeasurementChart from "./MeasurementChart";
import { IControl } from "../types";
import useControlMeasurements from "../../../hooks/useControlMeasurements";
import { useTranslation } from "react-i18next";

interface IClimateHumidityChartProps {
  control: IControl;
  width: number;
  height: number;
}

const ClimateHumidityChart = (props: IClimateHumidityChartProps) => {
  const { control, width, height } = props;
  const { value, valuesList } = useControlMeasurements(control, ["humidity"]);
  const { t } = useTranslation();

  if (!valuesList) {
    return null;
  }

  const draw: TStaticDrawFunction = (ctx) => {
    const chart = new MeasurementChartPainter(width, height);
    chart.drawPercentBars(ctx, valuesList[0]);
  };

  return (
    <MeasurementChart
      title={t("Humidity") + ` ${value}%`}
      draw={draw}
      width={width}
      height={height}
    />
  );
};

export default ClimateHumidityChart;
